// eslint-disable-next-line import/prefer-default-export
export const set = (state, works) => {
  state.works = works;
};
